export default __webpack_public_path__ + "static/media/cny-check-in-cn.85d6b08a.gif";